import type zh from '../zh/common';

/**
 * Frozen copy of the common text the UI showed before the zh/en switch, rendered while
 * UI_I18N_ENABLED is off (gamma / prod). Do not edit the text; add a key here only when
 * zh gains one, with the text the UI would show without the switch. Delete with the flag.
 */
const common: typeof zh = {
  language: {
    zh: '中文',
    en: 'English',
  },
};

export default common;
